'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loadmask = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactMotion = require('react-motion');

var _styles = require('./shared/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Loadmask = exports.Loadmask = function (_PureComponent) {
  _inherits(Loadmask, _PureComponent);

  function Loadmask() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Loadmask);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Loadmask.__proto__ || Object.getPrototypeOf(Loadmask)).call.apply(_ref, [this].concat(args))), _this), _this.willLeave = function () {
      return {
        opacity: (0, _reactMotion.spring)(0, _reactMotion.presets.gentle)
      };
    }, _this.getStyles = function () {
      var showLoadmask = _this.props.showLoadmask;


      if (showLoadmask) {
        return [{
          key: 'child',
          data: {},
          style: { opacity: (0, _reactMotion.spring)(1) }
        }];
      } else {
        return [];
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Loadmask, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var bgColor = this.props.bgColor;


      return _react2["default"].createElement(
        _reactMotion.TransitionMotion,
        {
          styles: this.getStyles(),
          willLeave: this.willLeave
        },
        function (items) {
          return _react2["default"].createElement(
            'div',
            { style: { position: 'relative', zIndex: 2000000 } },
            items.map(function (item) {
              return _react2["default"].createElement(
                'div',
                { key: item.key, className: 'box', style: { opacity: item.style.opacity } },
                _react2["default"].createElement(
                  'div',
                  { id: '__react-redux-loadmask__', style: (0, _styles2["default"])(bgColor) },
                  _react2["default"].createElement(
                    'div',
                    null,
                    _this2.props.children
                  )
                )
              );
            })
          );
        }
      );
    }
  }]);

  return Loadmask;
}(_react.PureComponent);

Loadmask.propTypes = {
  showLoadmask: _react.PropTypes.bool,
  bgColor: _react.PropTypes.string,
  children: _react.PropTypes.any
};
Loadmask.defaultProps = {
  bgColor: '#424242'
};


function mapStateToProps(state) {
  return {
    showLoadmask: state.loadmaskReducer.showLoadmask.length > 0
  };
}

exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(Loadmask);


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux-loadmask/lib/Loadmask.js
 ** module id = 498
 ** module chunks = 0
 **/